<template>
  <p class="text-left text-sm">
    <span class="font-bold">How Does Affirm Work?</span> Just enter some basic personal information and get a real-time
    credit decision. You will complete your application on the Affirm website. If you are approved and confirm a loan,
    your purchase will be on its way as soon as it's ready.
  </p>
</template>
